import React from "react";
import Keyword from "../../Components/Tracking/Keyword";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const KeywordPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Keyword date={query.date} />
    </React.Fragment>
  );
};

export default KeywordPage;
